export default __webpack_public_path__ + "static/media/leadsBanner.122fe66e.png";